module.exports = {"TXTCLI_Amount":{"id":"TXTCLI_Amount","defaultMessage":"Ποσό","track":"Amount"}}